import React, { PropTypes } from 'react';
import '../../styles/SidebarItem';
import '../../styles/SidebarAccordion';

let SidebarAccordion = React.createClass({
	displayName: 'SidebarAccordion',

	propTypes: {
		children: PropTypes.any,
		header: PropTypes.string.isRequired,
		iconClass: PropTypes.string,
		isActive: PropTypes.bool,
		isOpen: PropTypes.bool,
		onClick: PropTypes.func.isRequired
	},

	getAccordionClassName: function() {
		let className = 'sidebar-accordion';

		if (this.props.isOpen) {
			className += ' open';
		}

		if (this.props.isActive) {
			className += ' active';
		}

		return className;
	},

	render: function() {
		return (
			<div className={ this.getAccordionClassName() }>
				<div className="sidebar-accordion-header" onClick={ this.props.onClick }>
					<div className="header-icon">
						{
							this.props.iconClass ? (
								<i className={ this.props.iconClass } />
							) : ''
						}
					</div>
					<div className="sidebar-accordion-header-content">
						{ this.props.header }
					</div>
					<div className="sidebar-accordion-header-caret">
						<i className="fas fa-caret-right" />
					</div>
				</div>
				<div className="sidebar-accordion-content">
					{ this.props.children }
				</div>
			</div>
		);
	}
});

module.exports = SidebarAccordion;



// WEBPACK FOOTER //
// ./frontend/shared/js/components/SidebarAccordion.jsx